// import React, { useEffect, useState, useRef } from "react";
// import ReactECharts from "echarts-for-react";
// import { APIConstants } from "../../../Common/APIConstants";
// import { adjustTimeByFiveHoursThirtyMinutes } from "../../../Utils/DateConverstion";
// import dayjs from "dayjs";
// import { getAdjustedDate } from "../CommonFunctions";
// import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
// import { Card, Radio } from "antd";

// const SMMILSECStatistics = ({ theme, cardStyle }) => {
//   const { makeRequest } = useStoreUpdaterWithAPI();
//   const [selected, setSelected] = useState(201);
//   const correctDate = new Date(getAdjustedDate());
//   const defaultToDate = dayjs(correctDate).hour(6).minute(30).second(0);
//   const defaultFromDate = dayjs(correctDate)
//     .subtract(30, "days")
//     .hour(6)
//     .minute(30)
//     .second(0);
  
//   const [toDate, setToDate] = useState(defaultToDate);
//   const [fromDate, setFromDate] = useState(defaultFromDate);
//   const [loading, setLoading] = useState(true);
//   const [groupID,setGroupID]=useState([])
//   const [chartData, setChartData] = useState({ uniqueDates: [], series: [] });

//   const chartRef = useRef(null);

//   const formatEChartsBarOption = (responseData) => {
//     // Extract unique dates for the x-axis
//     const uniqueDates = [
//       ...new Set(responseData.map((item) => dayjs(item.createdOn).format("YYYY-MM-DD"))),
//     ];

//     // Group data by meterName
//     const meterGroups = {};
//     responseData.forEach((item) => {
//       if (!meterGroups[item.subGroupName]) {
//         meterGroups[item.subGroupName] = {};
//       }
//       meterGroups[item.subGroupName][dayjs(item.createdOn).format("YYYY-MM-DD")] =
//         item.subGroupConsumption;
//     });

//     // Create dynamic series
//     const series = Object.keys(meterGroups).map((subGroupName) => ({
//       name: subGroupName, // Meter name as legend
//       type: "bar",
//       data: uniqueDates.map((date) => meterGroups[subGroupName][date] || 0), // Fill missing dates with 0
//     }));

//     return { uniqueDates, series };
//   };

// //   const getResponse = async () => {
// //     setLoading(true);
// //     const inputData = {
// //       FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
// //       ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
// //     };

// //     try {
// //       const res = await makeRequest({
// //         type: APIConstants.GET,
// //         url: `${APIConstants.SMML_SEC_STATISTICS_ENERGY_CONSUMPTION}?GroupID=${selected}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
// //       });
// //       console.log(res)

// //       if (res && res.length > 0) {
// //         const response = formatEChartsBarOption(res);
// //         setChartData(response);

// //         // ✅ Dynamically update the chart
// //         if (chartRef.current) {
// //           chartRef.current.getEchartsInstance().setOption({
// //             xAxis: { data: response.uniqueDates },
// //             series: response.series,
// //           });
// //         }
// //       }
// //       else{
// //         setChartData([])
// //         if (chartRef.current) {
// //             chartRef.current.getEchartsInstance().setOption({
// //               xAxis: { data: []},
// //               series: [],
// //             });
// //           }
// //       }
// //     } catch (error) {
// //       console.log(error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// const getResponse = async () => {
//     setLoading(true);
//     const inputData = {
//       FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
//       ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
//     };

//     try {
//       const res = await makeRequest({
//         type: APIConstants.GET,
//         url: `${APIConstants.SMML_SEC_STATISTICS_ENERGY_CONSUMPTION}?GroupID=${selected}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
//       });

//       console.log(res);

//       if (res ) {
//         const response = formatEChartsBarOption(res);
//         setChartData(response);

//         // ✅ Dynamically update the chart
//         if (chartRef.current) {
//           chartRef.current.getEchartsInstance().setOption({
//             xAxis: { data: response.uniqueDates },
//             series: response.series,
//           });
//         }
//       } else {
//         // ✅ Ensure the chart shows empty data when API returns no response
//         setChartData({ uniqueDates: [], series: [] });

//         if (chartRef.current) {
//           chartRef.current.getEchartsInstance().setOption({
//             xAxis: { data: [] },
//             series: [],
//           });
//         }
//       }
//     } catch (error) {
//       console.log(error);
//       // ✅ Handle errors and reset the chart data
//       setChartData({ uniqueDates: [], series: [] });

//       if (chartRef.current) {
//         chartRef.current.getEchartsInstance().setOption({
//           xAxis: { data: [] },
//           series: [],
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
// };

//   useEffect(() => {
//     getResponse();
//   }, [selected]);

//   const barOption = {
//     legend: { top: "top" },
//     tooltip: {
//       trigger: "axis", // Shows tooltip when hovering over the axis
//       axisPointer: {
//         type: "shadow", // Highlights the bars in a shadow effect
//       },
//     },
//     xAxis: { type: "category", data: chartData.uniqueDates },
//     yAxis: { type: "value" },
//     series: chartData.series,
//   };
//   console.log(chartData)
  
//   useEffect(() => {
//       makeRequest({ 
//             type: APIConstants.GET, 
//             url: `${APIConstants.SMML_ENERGY_GROUP_ID}`
//           }).then((res) => {
//             console.log(res)
//             if (res && res.length) {
//                 setGroupID(res)
//             }
//           });
//   }, [])
  
//   console.log(barOption) 

//   return (
//     <div className="w-full h-[350px]">
//            <div style={{ textAlign: "center", padding: "20px" }}>
//            <Radio.Group 
//                 onChange={(e) => setSelected(e.target.value)}
//                 value={selected}
//             >
//                 {groupID.map((option) => (
//                     <Radio key={option.groupid} value={option.groupid}>
//                         {option.groupName}
//                     </Radio>
//                 ))}
//             </Radio.Group>
//     </div>
//       <Card  style={cardStyle}
//        title={
//         <span className={`${theme==='dark'?'text-white':'text-black'}` }>SMMIL SEC Statistics</span>
//       }
//       >
//         <ReactECharts ref={chartRef} option={barOption} />
//       </Card>
//     </div>
//   );
// }; 

// export default SMMILSECStatistics;



import React, { useEffect, useState, useRef } from "react";
import ReactECharts from "echarts-for-react";
import { APIConstants } from "../../../Common/APIConstants";
import { adjustTimeByFiveHoursThirtyMinutes } from "../../../Utils/DateConverstion";
import dayjs from "dayjs";
import { getAdjustedDate } from "../CommonFunctions";
import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
import { Card, Radio } from "antd";
import { useSelector } from "react-redux";

const SMMILSECStatistics = () => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const correctDate = new Date(getAdjustedDate());
  const defaultFromDate =  dayjs(correctDate).subtract(1, "day").startOf("day"); 
  const defaultToDate =  dayjs(correctDate).startOf("day");
  
  const [toDate, setToDate] = useState(defaultToDate);
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [loading, setLoading] = useState(true);
  const [groupID, setGroupID] = useState([]);
  const [selected, setSelected] = useState(groupID[0]?.groupid);
  const [chartData, setChartData] = useState({ uniqueDates: [], series: [] });

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const theme = isdarkMode
  console.log(theme)
  const isDark = theme === "dark";
  const textColor = isDark ? "#ffffff" : "#000000";
  // const backgroundColor = isDark ? "#151236" : "#ffffff";
  const borderColor = isDark ? "#333" : "#ddd";

  // Card Styling
  const cardStyle = {
    // backgroundColor,
    color: textColor,
    border: `1px solid ${borderColor}`,
  };
  const chartRef = useRef(null);

  const formatEChartsBarOption = (responseData) => {
    const uniqueDates = [...new Set(responseData.map((item) => dayjs(item.createdOn).format("YYYY-MM-DD")))];

    const meterGroups = {};
    responseData.forEach((item) => {
      if (!meterGroups[item.subGroupName]) { 
        meterGroups[item.subGroupName] = {};
      }
      meterGroups[item.subGroupName][dayjs(item.createdOn).format("YYYY-MM-DD")] = item.subGroupConsumption;
    });

    const series = Object.keys(meterGroups).map((subGroupName) => ({
      name: subGroupName,
      type: "bar",
      data: uniqueDates.map((date) => meterGroups[subGroupName][date] || 0),
    }));

    return { uniqueDates, series };
  };
  function getUnitOutputs(data) {
    const output = {
        Others: { Daily: null, MTD: null, subTarget: null },
        Thermal: { Daily: null, MTD: null, subTarget: null },
        ElectricalHTF: { Daily: null, MTD: null, subTarget: null },
        AirCompressor: { Daily: null, MTD: null, subTarget: null },
        Melting: { Daily: null, MTD: null, subTarget: null }
    };

    data.forEach(entry => {
        if (entry.subGroupName.includes('Others')) {
            if (entry.subGroupName.startsWith('Day')) {
                output.Others.Daily = entry.subGroupConsumption;
                output.Others.subTarget = entry.subTarget;
            } else if (entry.subGroupName.startsWith('MTD')) {
                output.Others.MTD = entry.subGroupConsumption;
            }
        } else if (entry.subGroupName.includes('Thermal')) {
            if (entry.subGroupName.startsWith('Day')) {
                output.Thermal.Daily = entry.subGroupConsumption;
                output.Thermal.subTarget = entry.subTarget;
            } else if (entry.subGroupName.startsWith('MTD')) {
                output.Thermal.MTD = entry.subGroupConsumption;
            }
        } else if (entry.subGroupName.includes('Electrical HTF')) {
            if (entry.subGroupName.startsWith('Day')) {
                output.ElectricalHTF.Daily = entry.subGroupConsumption;
                output.ElectricalHTF.subTarget = entry.subTarget;
            } else if (entry.subGroupName.startsWith('MTD')) {
                output.ElectricalHTF.MTD = entry.subGroupConsumption;
            }
        } else if (entry.subGroupName.includes('Air Compressor')) {
            if (entry.subGroupName.startsWith('Day')) {
                output.AirCompressor.Daily = entry.subGroupConsumption;
                output.AirCompressor.subTarget = entry.subTarget;
            } else if (entry.subGroupName.startsWith('MTD')) {
                output.AirCompressor.MTD = entry.subGroupConsumption;
            }
        } else if (entry.subGroupName.includes('Melting')) {
            if (entry.subGroupName.startsWith('Day')) {
                output.Melting.Daily = entry.subGroupConsumption;
                output.Melting.subTarget = entry.subTarget;
            } else if (entry.subGroupName.startsWith('MTD')) {
                output.Melting.MTD = entry.subGroupConsumption;
            }
        }
    });
    
    return {
        xAxis: {
            type: 'category',
            data: ['Others', 'Thermal', 'Electrical HTF', 'Air Compressor', 'Melting']
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                name: 'Day Actual',
                type: 'bar',
                data: [output.Others.Daily, output.Thermal.Daily, output.ElectricalHTF.Daily, output.AirCompressor.Daily, output.Melting.Daily]
            },
            {
                name: 'MTD Actual',
                type: 'bar',
                data: [output.Others.MTD, output.Thermal.MTD, output.ElectricalHTF.MTD, output.AirCompressor.MTD, output.Melting.MTD]
            },
            {
                name: 'Target',
                type: 'bar',
                data: [output.Others.subTarget, output.Thermal.subTarget, output.ElectricalHTF.subTarget, output.AirCompressor.subTarget, output.Melting.subTarget]
            }
        ]
    };
}


const transformDataForECharts = (data) => {
  const xAxisData = data.map(item => item.subGroupName);

  const numericalKeys = Object.keys(data[0]).filter(
    key => !['groupName', 'groupID', 'subGroupName', 'subGroupID', 'fromDate', 'toDate'].includes(key)
  );

  const series = numericalKeys.map(key => ({
    name: key==='daySubGroupConsumption'?'Daily ':key==='mtdSubGroupConsumption'?'MTD ':'Target',
    type: 'bar',
    data: data.map(item => item[key])
  }));

  return { xAxisData, series };
};

  const getResponse = async () => {
    setLoading(true);

    const inputData = {
      FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
      ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
    };

    try {
      const res = await makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.SMML_SEC_STATISTICS_ENERGY_CONSUMPTION}?GroupID=${selected}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}`,
      });

      if (res && res.length > 0) {
        console.log(res)
        console.log(transformDataForECharts(res))
        setChartData(transformDataForECharts(res));
      } else {
        setChartData({ uniqueDates: [], series: [] });
      }
    } catch (error) {
      console.log(error);
      setChartData({ uniqueDates: [], series: [] });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getResponse();
  }, [selected]);
  console.log(theme)
 
  useEffect(() => {
    console.log(chartData)
    if (chartRef.current) {
      const myChart = chartRef.current.getEchartsInstance();
      if (myChart) {
        
        const option = {
          backgroundColor: theme  ? "#2d3748" : "#ECFDF3",
          title: {
            text: "SMML Consumption & SEC Energy Statistics",
            left: "left",
            top: "5px",
            textStyle: { color: theme  ? "white" : "black" },
          },
          tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
          legend: { bottom: "0px", textStyle: { color: theme  ? "white" : "black" } },
          grid: { left: "3%", right: "4%", bottom: "10%", containLabel: true },
          xAxis: {
            type: "category",
            data: chartData?.xAxisData,
            axisLabel: {
              color: theme  ? "white" : "black",
              rotate: 45,
            },
          },
          yAxis: {
            type: "value",
            axisLabel: { color: theme  ? "white" : "black", fontSize: "10", fontWeight: "bold" },
          },
          series: chartData.series,
        };

        myChart.setOption(option, true);

        const resizeHandler = () => myChart.resize();
        window.addEventListener("resize", resizeHandler);

        return () => {
          window.removeEventListener("resize", resizeHandler);
          myChart.dispose();
        };
      }
    }
  }, [chartData, theme]);

  useEffect(() => {
    makeRequest({ type: APIConstants.GET, url: `${APIConstants.SMML_ENERGY_GROUP_ID}` }).then((res) => {
      if (res && res.length) {
        setSelected(res?.[0]?.groupid);
        setGroupID(res);
      }
    });
  }, []);

  console.log(theme)
  console.log(groupID)
  return (
    <div className="w-full">
      <div style={{ textAlign: "center", padding: "20px" }}>
        <Radio.Group onChange={(e) => setSelected(e.target.value)} value={selected}>
          {groupID.map((option) => (
            <Radio className={`${theme?'text-white':'text-black'} w-28`} 
             key={option.groupid} value={option.groupid}>
              {option.groupName}
            </Radio>
          ))}
        </Radio.Group>
      </div> 
      <Card style={cardStyle}  
      className={`${theme?'bg-[#2d3748]':' bg-[#ECFDF3] '}  `}
      >
        <ReactECharts ref={chartRef} option={{}}  style={{ width: "100%", height: "600px" }} />
      </Card>
    </div>
  );
};

export default SMMILSECStatistics;

